import React from "react";
import { Select } from "antd";
import { useSelector } from "react-redux";

export const GroupFormSelect = ({id="", value="", onChange=e=>{}, allowAddNew=true, groups=null, ...props}) => {
  
  const {all_group_list} = useSelector(state => state.flights);
  
  return (
    <Select mode={allowAddNew ? 'tags' : 'multiple'} value={value} onChange={onChange} {...props}>
      {(groups || all_group_list || []).map((group, index) => <Select.Option value={group.value} key={index}>{group.label}</Select.Option>)}
    </Select>
  );
};